import User from "../User";

class LogHandler {

   public static async display(...aMessages: any[]): Promise<void> {
        try {
            const sCaller = LogHandler.getCallerInfo();
            const { sUname, iElapsedMs } = await LogHandler.waitForUsername();
            const aDevUsers = ["alex", "dcarbo"];

            if (aDevUsers.includes(sUname)) {
                const sPrefix = iElapsedMs >= 100 
                    ? `[${sCaller}] (showing after ${iElapsedMs}ms)` 
                    : `[${sCaller}]`;
                console.log(sPrefix, ...aMessages);
            }
        } catch (e) {
            console.error("Failed to log message:", e);
        }
    }

    private static async waitForUsername(iTimeoutMs = 10000, iIntervalMs = 100): Promise<{ sUname: string; iElapsedMs: number }> {
        const iStart = Date.now();
        let sUname = User.getInstance().getUsername();

        while (!sUname && Date.now() - iStart < iTimeoutMs) {
            await new Promise((resolve) => setTimeout(resolve, iIntervalMs));
            sUname = User.getInstance().getUsername();
        }

        const iElapsedMs = Date.now() - iStart;
        return { sUname, iElapsedMs };
    }

    private static getCallerInfo(): string {
        const oError = new Error();
        const aStackLines = oError.stack?.split("\n") ?? [];
        // aStackLines[0] = "Error"
        // aStackLines[1] = getCallerInfo (this function)
        // aStackLines[2] = displayLog
        // aStackLines[3] = who called displayLog
        const sCallerLine = aStackLines[3] ?? "";
        const oMatch = sCallerLine.match(/at (.+)/);
        return oMatch ? oMatch[1].trim() : "unknown caller";
    }
    
}

export default LogHandler;
